module.exports = __webpack_public_path__ + "static/media/new-shoal-icon.ada62037.svg";